import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { gettext } from "../../../shared/utils/legacy";
import Icon from "../../../shared/icons/Icon";

interface NavBarSearchDropDownProperties {
  active?: string;
  label?: string;
  onClick: (id: string) => void;
  children: React.ReactNode;
  data: Array<[string, string]>;
}

const NavBarSearchDropDown = ({
  onClick,
  active,
  label,
  children,
  data,
}: NavBarSearchDropDownProperties) => {
  const [filter, setFilter] = useState("");

  // eslint-disable-next-line eqeqeq
  const title = data.find(([id, name]) => id === active)?.[1] || "";
  const [searchResults, setSearchResults] = useState<[string, string][]>([]);

  React.useEffect(() => {
    const results = data.filter(([id, name]) => name.toLocaleLowerCase().includes(filter));
    setSearchResults(results);
  }, [data, filter]);

  return (
    <Dropdown className="c-navbar__nav-item c-navbar__nav-item--dropdown dropdown-scroll" as={"li"}>
      <Dropdown.Toggle as={"button"} bsPrefix={"c-btn c-btn--tertiary c-btn--sm"}>
        {label ? (
          <span>
            {label}: {title}
          </span>
        ) : (
          <span>{title}</span>
        )}
        <Icon icon={"chevron down"} size={"fa-sm"} />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <form className="form-inline px-1">
          <input
            autoFocus={true}
            className="form-control"
            type="search"
            placeholder={gettext("Search")}
            aria-label={gettext("Search")}
            onChange={(e) => setFilter(e.target.value.toLowerCase())}
          />
        </form>
        <ul className={"dropdown-menu-scrollarea"}>
          {searchResults.length > 0 ? (
            searchResults.map(([id, name]) => (
              <Dropdown.Item
                className={"text-wrap"}
                as={"li"}
                key={id}
                active={id === active}
                onClick={() => onClick(id)}
              >
                {name}
              </Dropdown.Item>
            ))
          ) : (
            <Dropdown.Item as={"li"} key={0}>
              {gettext("No search results")}
            </Dropdown.Item>
          )}
        </ul>
        {children}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NavBarSearchDropDown;
